import generateTypes from '../utils/generateTypes';

export const GET_PARTICIPANTS = generateTypes('GET_PARTICIPANTS');
export const RESET_PARTICIPANTS = generateTypes('RESET_PARTICIPANTS');
